module.exports = __webpack_public_path__ + "img/rope_ThimbleBraid_2.4e1362f7.png";